import { forwardRef, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-navi';

import { ModalDefaultProps } from 'components/Modal';
import { CommonUtilsContext } from 'contexts/commonUtils';
import { ModalTemplate } from 'components/ModalTemplate';
import { Logo } from 'components/Logo';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { useTheme } from 'hooks/theme';
import { TELEGRAM_URL, WHATSAPP_URL } from 'components/general/Footer';

import { ScNetworks } from './styled';

import networkBg from 'assets/images/socialNetworks/network-modal-bg.jpg';
import networkCharacter from 'assets/images/socialNetworks/network-modal-character.png';
import { ReactComponent as TgIcon } from 'assets/images/socialNetworks/telegram-icon.svg';
import { ReactComponent as WaIcon } from 'assets/images/socialNetworks/whats-app-icon.svg';

export const NetworkModal = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const {
      t,
      i18n: { language },
    } = useTranslation('common');

    const { images } = useTheme();

    const { isMobileS } = useContext(CommonUtilsContext);

    const modalSettings: ModalTemplateSettings = useMemo(() => {
      return isMobileS
        ? {
            type: 'mobile',
            mode: {
              type: 'background-custom',
              src: networkBg,
              position: 'left top',
            },
          }
        : {
            type: 'desktop',
            size: 'large',
            mode: {
              type: 'background-custom',
              src: networkBg,
              position: 'right top',
            },
          };
    }, [isMobileS]);

    return (
      <ModalTemplate ref={ref} onClose={onClose} settings={modalSettings}>
        <ScNetworks>
          <div className={`content ${language.toLowerCase()}`}>
            <Logo height={28} />

            <div className="description">{t('socialNetworks.modalText')}</div>

            <div className="networks">
              <div>
                <Link target={'_blank'} href={TELEGRAM_URL}>
                  <TgIcon />
                  <span>{t('socialNetworks.followOnTelegram')}</span>
                  <images.arrowLeftIcon.component />
                </Link>
              </div>
              <div>
                <Link target={'_blank'} href={WHATSAPP_URL}>
                  <WaIcon />
                  <span>{t('socialNetworks.followOnWhatsApp')}</span>
                  <images.arrowLeftIcon.component />
                </Link>
              </div>
            </div>
          </div>

          <img src={networkCharacter} className="character" alt="character" />
        </ScNetworks>
      </ModalTemplate>
    );
  }
);
